import * as React from "react";
import PropTypes from "prop-types";

import { BindingPath } from "../../../Engine/Core/CoreTypes";
import { createHocDisplayName } from "../../TypingUtils";
import { reject } from "../../../../../Common/TypingUtils";

export const tablePathContextTypes = { stickyTablePath: PropTypes.string };

export interface TablePathLegacyContext {
    stickyTablePath: BindingPath;
}

const TablePathContextObject = React.createContext<string | undefined>(undefined);

interface TablePathContextProviderProps {
    tablePath: BindingPath;
    children: React.ReactNode;
}

export function useTablePath(): BindingPath {
    return React.useContext(TablePathContextObject) ?? reject("TablePath is not provided");
}

export class TablePathProvider extends React.Component<TablePathContextProviderProps> {
    public static childContextTypes = tablePathContextTypes;

    public getChildContext = (): TablePathLegacyContext => ({ stickyTablePath: this.props.tablePath });

    public render(): JSX.Element {
        return (
            <TablePathContextObject.Provider value={this.props.tablePath}>
                {this.props.children}
            </TablePathContextObject.Provider>
        );
    }
}

export function withTablePath<P>(Comp: React.ComponentType<P & { tablePath: BindingPath }>): React.ComponentType<P> {
    function WithTablePathWrapper(props: P): JSX.Element {
        const tablePath = useTablePath();
        return <Comp {...props} tablePath={tablePath} />;
    }
    WithTablePathWrapper.displayName = createHocDisplayName(Comp, "TablePath");
    return WithTablePathWrapper;
}
